import cn from 'classnames';
import { Trans } from 'react-i18next';
import { ThemeConsumer } from '../theme';
import { Text } from '../text';
import { Card } from 'ui';
import { TelehealthRequest } from 'features/events/components/Telehealth';
import { CommunityListItem } from 'models';
import { getCreateEventPermissions } from 'features/events/utils';
import { isRequestTelehealthVisitEnabled } from 'common/validators';
import { TodosWidget } from 'features/todos';
import { EventsList } from '../../widgets/events-list';

const SidebarRenderer = ({
  viewer,
  navigateToEvents,
  numberOfNotifications,
  unreadMessages,
  hideTodosFeedCta,
  feedbackOptions,
}) => {
  const { isTelehealthButtonAvailable } = getCreateEventPermissions({ viewer });
  const isTelehealthVisitRequestEnabled = isRequestTelehealthVisitEnabled();

  const isTelehealthButtonVisible = isTelehealthButtonAvailable && isTelehealthVisitRequestEnabled;

  return (
    <ThemeConsumer>
      {(theme) => (
        <div className={cn('main-sidebar', { 'main-sidebar--extended': isTelehealthButtonVisible })}>
          {isTelehealthButtonVisible ? (
            <Card className="main-sidebar__telehealth">
              <TelehealthRequest
                buttonType="secondary"
                viewer={viewer}
                communities={viewer.joined_communities.map((community) => new CommunityListItem(community))}
              />
            </Card>
          ) : null}

          <TodosWidget
            numberOfNotifications={numberOfNotifications}
            unreadMessages={unreadMessages}
            className="main-sidebar__todos"
            hideTodosFeedCta={hideTodosFeedCta}
            viewer={viewer}
          />

          <Card
            id="events-card"
            marginBottom={false}
            extra={
              <span
                style={{
                  color: theme.color.brand,
                  cursor: 'pointer',
                  fontSize: 12,
                  fontWeight: 'bold',
                }}
                onClick={navigateToEvents}
              >
                <Trans>See all</Trans>
              </span>
            }
            title={
              <Text color={theme.color.lightGray} size="12px" weight="600" lineHeight="14px">
                <Trans>Events</Trans>
              </Text>
            }
            className="main-sidebar__events"
          >
            <EventsList loadMore={false} feedbackOptions={feedbackOptions} />
          </Card>
        </div>
      )}
    </ThemeConsumer>
  );
};

export const Sidebar = SidebarRenderer;
